import React from 'react';
import { Input, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ReactComponent as SoundIcon } from '../../../design-system/Icons/soundIcon.svg';
import DSBox from '../../../design-system/DSBox';
import DSPaper from '../../../design-system/Paper/DSPaper';
import DSValueTypography from '../../../design-system/Typography/DSValueTypography';
import { FILE_VALIDATION } from '../../../consts/dragAndDropInputs';

type KlydoChimeInputEmptyProps = {
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
};

const KlydoChimeInputEmpty = ({
  onFileChange,
  fileInputRef,
}: KlydoChimeInputEmptyProps) => {
  const { spacing, palette } = useTheme();

  return (
    <DSBox component="label" sx={{ width: '100%', cursor: 'pointer' }}>
      <DSPaper
        sx={{
          display: 'flex',
          padding: spacing(2, 3),
          justifyContent: 'space-between',
          alignItems: 'center',
          alignSelf: 'stretch',
          borderRadius: '28px',
          border: `2px dashed ${palette.white[12]}`,
          background: 'transparent',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: palette.white[5],
            borderColor: palette.white[20],
            '& .add-icon': {
              color: palette.white[90],
            },
          },
        }}
      >
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: spacing(1),
          }}
        >
          <SoundIcon
            style={{ color: palette.text.secondary, width: 16, height: 18 }}
          />
          <DSValueTypography color={palette.gray[119]}>
            MP3, WAV max duration 40 sec
          </DSValueTypography>
        </DSBox>
        <AddIcon
          className="add-icon"
          sx={{
            color: palette.white[70],
            fontSize: 24,
            transition: 'color 0.2s ease',
          }}
        />
        <Input
          ref={fileInputRef}
          inputProps={{
            accept: FILE_VALIDATION.audio.acceptedExtensions.join(', '),
          }}
          type="file"
          onChange={onFileChange}
          sx={{ display: 'none' }}
        />
      </DSPaper>
    </DSBox>
  );
};

export default KlydoChimeInputEmpty;
